<script lang="ts">
    import type { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
    import { map } from "rxjs";

    import type { RewardsTranslationNamespaces } from "../constants/constants";
    import type RewardsAmountFormatter from "../lib/RewardsAmountFormatter/RewardsAmountFormatter";

    //Props
    export let points: number;
    export let amountFormatter: RewardsAmountFormatter;
    export let i18n: GwI18n;
    export let pointsNamespace: RewardsTranslationNamespaces;

    const pointsNameSingular$ = i18n.selectT(
        pointsNamespace,
        "points_name_singular"
    );
    const pointsNamePlural$ = i18n.selectT(
        pointsNamespace,
        "points_name_plural"
    );

    $: formattedPoints$ = amountFormatter.format(points);
    $: singularOrPluralPointsName$ = formattedPoints$.pipe(
        map((formattedPoints) =>
            formattedPoints === 1 ? $pointsNameSingular$ : $pointsNamePlural$
        )
    );
</script>

<slot
    value={{
        points: $formattedPoints$,
        pointsName: $singularOrPluralPointsName$,
        pointsNameSingular: $pointsNameSingular$,
        pointsNamePlural: $pointsNamePlural$,
    }}
>
    {$formattedPoints$}
    {$singularOrPluralPointsName$}
</slot>
